module.exports = {
      id: "illustrations:search-usage",
      viewBox: "0 0 294 330",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:search-usage",
      toString: function () {
        return this.url;
      }
    }